import { r as registerInstance, h, e as Host, g as getElement } from './index-6c727dca.js';

const epiHintCss = ".epi-hint{display:inline-block;font-size:clamp(1px, 1.4rem, 14px);font-weight:400;color:var(--richBlack);line-height:1.44}";

const EpiHint = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.klassName = `epi-hint`;
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender() { }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { class: this.klassName }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
EpiHint.style = epiHintCss;

export { EpiHint as epi_hint };
